import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './Section.scss';

interface IOwnProps {
  spacingBottom?: 'default' | 'half' | 'no';
  readOnly?: boolean;
  blockFor?: string;
}

const Section: React.SFC<IOwnProps> = ({ children, spacingBottom, readOnly, blockFor }) => {
  const sectionClassNames = cx({
    [Styles.section]: true,
    [Styles.half]: spacingBottom === 'half',
    [Styles.clear]: spacingBottom === 'no' || readOnly,
  });

  return <div data-block-for={blockFor} className={sectionClassNames}>{children}</div>;
};

export default Section;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/Section/Section.tsx